export default __webpack_public_path__ + "static/media/btn-malvorlagen.220405c4.png";